import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    public showSuccessToast(message: string): Observable<boolean> {
        return from(this.toast(message, 'success'))
            .pipe(map((result: SweetAlertResult) => !result.dismiss));
    }

    public showErrorToast(message: string): Observable<boolean> {
        return from(this.toast(message, 'error'))
            .pipe(map((result: SweetAlertResult) => !result.dismiss));
    }

    private async toast(message: string, icon: 'error' | 'success'): Promise<SweetAlertResult> {
        return Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        }).fire({
            icon,
            title: message
        });
    }
}
